import React from "react";

const NoRecordFound = ({ title, icon }) => {
  return (
    <div className="no_record_found g_center h-100">
      {icon && <img src={icon} alt={title} width={120} height={120} />}
      <p>{title}</p>
    </div>
  );
};

export default NoRecordFound;
